import React from "react";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { Toast } from "primereact/toast";

const EditCustomer = (props) => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user?.encrypted_id;

  const show = props.show;
  const setShow = props.setShow;
  const setCounter = props.setCounter;
  const counter = props.counter;
  const customers = props.customerData;

  // console.table(customers);

  const handleClose = () => setShow(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [star, setStar] = useState(false);
  const [note, setNote] = useState("");
  const [address, setAddress] = useState("");
  const [dob, setDob] = useState("");
  const [cust_id, setCust_id] = useState("");
  const [created_by, setCreated_by] = useState();
  const [created_at, setCreated_at] = useState();
  const [created_from, setCreated_from] = useState();
  const [last_update, setLast_update] = useState();

  useEffect(() => {
    if (customers) {
      setName(customers.name || "");
      setPhone(customers.phone || "");
      setEmail(customers.email || "");
      setStar(customers.isStarred || false);
      setNote(customers.description || "");
      setAddress(customers.address || "");
      setDob(customers.dob || "");

      setCreated_by(customers.created_by_name || "");
      setCreated_at(customers.created_at_at || "");
      setCreated_from(customers.created_since || "");
      setLast_update(customers.updated_at_at || "");
      setCust_id(customers.cust_id);
    }
  }, [props]);

  const edit = async () => {
    setLoading(true);

    try {
      const response = await axios.post(main_link + "updateCustomer", {
        name,
        email,
        phone,
        star,
        note,
        address,
        dob,
        user_id,
        cust_id,
      });
      setLoading(false);
      if (response.data.message === "No Changes Requested.") {
        toast.current.show({
          severity: "info",
          summary: "info",
          detail: "No Changes Requested.",
        });
        setShow(false);
        setCounter(counter + 1);
      }

      if (response.data.message === "Saved Successfully.") {
        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Saved Successfully.",
        });
        setShow(false);
        setCounter(counter + 1);
      }
      if (
        response.data.message ==
        "You can't update a customer who doesn't belong to your customers."
      ) {
        toast.current.show({
          severity: "info",
          summary: "info",
          detail:
            "You can't update a customer who doesn't belong to your customers.",
        });
        setShow(false);
        setCounter(counter + 1);
      }
    } catch (error) {
      // console.log(error);
      setLoading(false);
      let errorMessage = "";
      Object.values(error.response?.data?.errors || {}).forEach(
        (errorArray) => {
          errorArray.forEach((error) => {
            errorMessage += error + " ";
          });
        }
      );
      toast.current.show({
        severity: "error",
        summary: "error",
        detail: errorMessage,
      });
      // toast.error(<div dangerouslySetInnerHTML={{ __html: errorMessage }} />);
    }
  };

  const remove = async () => {
    var answer = window.confirm("Are you sure you want to " + name);
    if (answer) {
      try {
        const response = await axios.post(main_link + "remove_customer", {
          cust_id,
          user_id,
        });

        if (response.data.message == "Removed Successfully.") {
          toast.current.show({
            severity: "success",
            summary: "success",
            detail: "Customer Removed Successfully.",
          });
          setShow(false);
          setCounter(counter + 1);
        }

        if (
          response.data.message ==
          "You can't remove a customer who doesn't belong to your customers."
        ) {
          toast.current.show({
            severity: "info",
            summary: "info",
            detail:
              "You can't remove a customer who doesn't belong to your customers.",
          });
          setShow(false);
          setCounter(counter + 1);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header className="bg-orange" closeButton>
          <Modal.Title>Edit Customer: {customers.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  defaultValue={customers.name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="email"
                  defaultValue={customers.email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  defaultValue={customers.phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Birth Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder=""
                  defaultValue={customers.dob}
                  onChange={(e) => setDob(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Customer Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  defaultValue={customers.address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Star</Form.Label>
                <Form.Check
                  type="checkbox"
                  label="Star?"
                  checked={star}
                  onChange={(e) => setStar(e.target.checked)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Any Note ..."
                  defaultValue={customers.description}
                  onChange={(e) => setNote(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <hr />

          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Created AT</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="0"
                  value={customers.created_at_at}
                  disabled
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Created From</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="0"
                  value={customers.created_since}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Last Update</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="0"
                  value={customers.updated_at_at}
                  disabled
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Created By</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="0"
                  value={customers.created_by_name}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="modal-footer justify-content-between">
          <Button
            type="button"
            className="btn btn-default bg-white"
            data-dismiss="modal"
            onClick={handleClose}
          >
            Close
          </Button>

          <div className="modal-footer justify-space-between">
            {" "}
            <Button variant="danger" className="" onClick={remove}>
              <i className="fa fa-trash"> </i> Remove
            </Button>
            {!loading && (
              <Button variant="success" onClick={edit}>
                Save
              </Button>
            )}
            {loading && (
              <Button variant="success" disabled>
                Saving...
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditCustomer;
